import { Link } from '@tanstack/react-router';

export type BreadcrumbItem = { label: string; href?: string; active?: boolean };

export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <div className="about-author-content">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {items.map((it, i) => (
            <li
              key={i}
              className={`breadcrumb-item${it.active ? ' active' : ''}`}
              aria-current={it.active ? 'page' : undefined}
            >
              {it.href && !it.active ? <Link to={it.href as any}>{it.label}</Link> : it.label}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}
